import { render } from "./group-product-packages.vue?vue&type=template&id=77a64c6a&scoped=true"
import script from "./group-product-packages.vue?vue&type=script&lang=js"
export * from "./group-product-packages.vue?vue&type=script&lang=js"

import "./group-product-packages.vue?vue&type=style&index=0&id=77a64c6a&scoped=true&lang=css"
import "./group-product-packages.vue?vue&type=style&index=1&id=77a64c6a&lang=css"
import "./group-product-packages.vue?vue&type=style&index=2&id=77a64c6a&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\montalvo.ti\\front-on\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77a64c6a"]])

export default __exports__